<template>
  <div :id="element">
    <slot><div v-html="content"></div></slot>
  </div>
</template>

<script>
const $ = require('jquery')
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'summernote/dist/summernote.css'
import 'summernote/dist/summernote.min.js'

export default {
  name: 'Summernote',
  data () {
    return {
      element: `summernote_${new Date().getTime()}`
    }
  },
  props: {
    config: {
      type: Object
    },
    ready: {
      type: Function
    },
    content: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      const defaultConfig = {
        lang: 'es',
        toolbar: [
          ['history', ['undo', 'redo']],
          ['style', ['style']],
          ['font', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
          ['fontsize', ['fontsize', '2']],
          ['fontname', ['fontname']],
          ['link'],
          ['insert', ['picture', 'linkImage']],
          ['video'],
          ['forecolor'],
          ['backcolor'],
          ['para', ['ul', 'ol', 'paragraph', 'height']],
          ['codeview']
        ],
        placeholder: 'Escribe aquí..',
        height: 400,
        width: '100%',
        tabsize: 2,
        focus: true,
        fontSizes: ['8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '20', '24', '28', '32', '36', '40', '50', '60'],
        fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'Montserrat'],
        callbacks: {
          onInit: () => {
            this.$emit('ready', this)
          },
          onChange: (contents) => {
            this.$emit('update:content', contents || '')
          },
          onEnter: () => {
            this.$emit('enter')
          },
          onFocus: () => {
            this.$emit('focus')
          },
          onBlur: () => {
            this.$emit('blur')
          },
          onKeyup: e => {
            this.$emit('keyup', e)
          },
          onKeydown: e => {
            this.$emit('keydown', e)
          },
          onPaste: e => {
            this.$emit('paste', e)
          },
          onMediaDelete: (child, totalParent) => {
            const imgElement = child[0]
            const parentContainer = totalParent[0]
            const parentAnchor = parentContainer.querySelector(`[href="${imgElement.dataset.link}"]`)
            if (parentAnchor) {
              parentAnchor.remove()
            }
          },
          onImageUpload: files =>  {
            const maxSize = 1048576
            const file = files[0]

            if (file.size > maxSize) {
              this.$alert(this.$t('La imagen es demasiado grande. El tamaño máximo permitido es de 1 MB.'))
            } else {
              const vueContext = this
              const reader = new FileReader()
              reader.onloadend = function () {
                $(`#${  vueContext.element}`).summernote('insertImage', reader.result)
              }
              reader.readAsDataURL(file)
            }
          }
        },
        buttons: {
          linkImage: (context) => {
            const ui = $.summernote.ui
            const $button = ui.button({
              contents: '<i class="fa fa-link"/>',
              tooltip: 'Add link to image',
              click: () => {
                const selection = document.getSelection()
                const selectedNode = selection.anchorNode
                const $div = $(selectedNode)
                const $selectedImage = $div.find('img:first')
                if ($selectedImage.length === 0) {
                  this.$alert(this.$t('Por favor, selecciona una imagen primero.'))
                  return
                }
                const $dialog = ui.dialog({
                  title: 'Insertar enlace',
                  body: '<div class="form-group">' +
                        '<label for="image-url">URL de la imagen:</label>' +
                        '<input id="image-url" class="form-control" type="text" placeholder="https://tu-imagen.com" />' +
                        '</div>',
                  footer: '<button class="btn btn-primary" id="insert-link">Insertar</button>' +
                          '<button class="btn btn-secondary" data-dismiss="modal">Cancelar</button>'
                }).render().appendTo('body')
                $dialog.modal('show')
                $dialog.find('#insert-link').click(function() {
                  const linkUrl = $dialog.find('#image-url').val()
                  if (linkUrl) {
                    const $link = $('<a>', {
                      href: linkUrl,
                      target: '_blank'
                    })
                    $selectedImage.attr('data-link', linkUrl)
                    $selectedImage.wrap($link)
                  }
                  $dialog.modal('hide')
                })
              }
            })

            return $button.render()
          }
        }
      }

      const config = Object.assign({}, defaultConfig, this.config, {
        defaultValue: this.content || ''
      })
      $(`#${  this.element}`).summernote(config)
      $(`#${  this.element}`).summernote('foreColor', 'black')
    })
  },
  methods: {
    summernote (...args) {
      $(`#${  this.element}`).summernote(...args)
    },
    ui () {
      return $.summernote.ui
    }
  }
}
</script>
<style>
.summernote-img {
  max-width: 100%;
}
.note-btn {
  background-color: white !important;
}
.note-modal-backdrop {
    z-index: 1031 !important;
}
.note-modal-footer {
  height: 60px !important;
}
.note-toolbar, .popover-content {
    color: #333;
    background-color: #f5f5f5;
    border-bottom: 1px solid;
    border-color: #ddd;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}
</style>